<template>
	<v-container fluid ma-0 pa-0>
		<v-layout row wrap justify-center>
			<v-flex xs12 my-3>
				<v-card flat class="tmplt-title">
					<slot name="title" />
				</v-card>
			</v-flex>
			<v-flex xs12 text-xs-left px-4 pb-4 pt-0>
				<v-card flat class="tmplt-content">
					<slot name="content" />
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
  name: 'pagetemplate',
  data () {
    return {
      
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PageTemplate.vue